import gql from 'graphql-tag';

export const CHECK_IN_SEND_WORK_ITEMS = gql`
  mutation CheckInSendWorkItems($taskId: SEND_STA_TASK_ID!, $workItemIds: [String!]!) {
    checkInSendWorkItems(taskId: $taskId, workItemIds: $workItemIds)
  }
`;
